import {ref} from 'vue'
import axios from 'axios'
import {log} from "@/composables/useLog"
import {BASE_URL} from "@/composables/url_config";
  const error = ref(null)
export const addNewUserApi = async (token, form) => {
    log("welcome in addNewUserApi cu parametrii " )
    log("token")
    log(token)
    log(form)
    const API_URL =`${BASE_URL}/home/addNewUserApi`;
    log("API_URL="+API_URL)
    error.value = null
    try {
        error.value = null
        const headers= {
            'Content-Type': 'application/json',
            'Authorization':`Bearer ${token}`
        }
        const params = {
            username: form.username,
            name: form.name,
            email: form.email,
            phone: form.phone,
            password: form.password,
            default_role: form.default_role || '',
            client_id:form.client_id
        };
        log("params->")
        log(params)
        const result = await axios.post(API_URL, params, { headers });
        log("parameters data send:")
        log ("result.data=");
        log (result);
        log (result.data);
        if(result.data.error==true){
            alert(result.data.message)
        }
        return result.data
    } catch (err){
        log("am intrat pe la catch (err) in addNewUserApi")
        log(err.value)
        error.value=err.value
    }
}

const useAddNewUserApi = () => {
        return { addNewUserApi };
}
export default useAddNewUserApi
